import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { Core2Config } from '../../shared/core2Config';
import { DgMktTreatmentExtensionContainerModel } from '../../../../../../models/';

@Injectable({
  providedIn: 'root',
})
export class DgMktTreatmentExtensionService extends BaseApiTemplateService<DgMktTreatmentExtensionContainerModel> {
  readonly url =
    Core2Config.TENANT_DOMAIN_URL_PREFIX +
    Core2Config.DGMKT_MODULE_PREFIX +
    'treatments-exts';

  constructor(http: HttpClient) {
    super();
    this.apiUrl =
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.DGMKT_MODULE_PREFIX +
      'treatments-exts';
    this.endpoint_path =
      Core2Config.DOMAIN_URL_PREFIX +
      Core2Config.DGMKT_MODULE_PREFIX +
      'treatments-exts';
    this.httpClient = http;
  }
}
